import React from "react";
import classes from "../Liquidity/styles.module.css";
import { Link } from "react-router-dom";
import WhyChoosePrimeBridge from "../WhyChoosePrimeBridge/WhyChoosePrimeBridge";
import WalletIcon from "../../icons/WalletIcon";
import ShieldIcon from "../../icons/ShieldIcon";
import MonitorIcon from "../../icons/MonitorIcon";
import WalletArrowUpIcon from "../../icons/WalletArrowUpIcon";
import UserHeadsetIcon from "../../icons/UserHeadsetIcon";

const solutionsList = [
  {
    icon: <WalletIcon />,
    title: "Branded Instant Funding Platform",
    description:
      "Offer your students a white-labeled funding experience with customizable rules, fast onboarding, and scalable account plans.",
  },
  {
    icon: <ShieldIcon />,
    title: "Built-in Risk Management",
    description:
      "Stay protected with automated risk monitoring, drawdown enforcement, and profit target validation—modeled after our experience managing 70+ prop firms.",
  },
  {
    icon: <MonitorIcon />,
    title: "Performance Tracking & Dashboards",
    description:
      "Access powerful analytics with trader leaderboards, account dashboards, and real-time equity tracking.",
  },
  {
    icon: <WalletArrowUpIcon />,
    title: "Payouts & Scaling",
    description:
      "Set your payout cycles, scaling plans, and profit share percentages. We manage the logistics and capital reserves.",
  },
  {
    icon: <UserHeadsetIcon />,
    title: "Ongoing Support & Optimization",
    description:
      "From custom trading rules to community launch strategy—we work with you to build a sustainable, long-term prop offering.",
  },
];

const categories = [
  "Trading Educators & Mentors",
  "Influencer Communities",
  "Trading Discord/Telegram Groups",
  "Academies & Courses",
  "Signal Providers & Portfolio Managers",
];

const PageBody = () => {
  return (
    <div className={classes.propTradingSolutions}>
      <div className={classes.hero}>
        <p className={classes.title}>Prop Trading Solutions</p>
        <p className={classes.message}>
          Partner with us to provide funding to your students – Fast, Flexible,
          Fully Managed
        </p>
      </div>

      <div className={classes.contentContainer}>
        <h3 className={classes.heading}>Overview</h3>

        <p className={classes.info}>
          We help trading educators, communities, and academies unlock new
          revenue streams by launching their proprietary trading programs or
          bundling them with their existing offerings.
        </p>

        <p className={classes.info}>
          With Prime Bridge's turnkey infrastructure, you can offer branded
          instant funding, performance tracking, scaling, and profit splits—all
          without managing backend systems or financial risk.
        </p>

        <p className={classes.info}>
          If you teach trading, we'll help you fund traders.
        </p>

        <div className={classes.solutionsSection}>
          <h3 className={classes.heading}>Our Solution Includes</h3>

          <div className={`row mt-5`}>
            {solutionsList.map((item, i) => (
              <div
                className={`col-12 col-md-4 mb-5  pe-md-4 ${classes.solutionItem}`}
                key={i}
              >
                <div className=" d-flex align-items-center gap-2 mb-3">
                  {item.icon}
                  <h5>{item.title}</h5>
                </div>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.categoriesSection}>
          <h3 className={`text-md-center ${classes.heading}`}>Who’s it for?</h3>
          <div className={`${classes.horizontalCategory} mt-5`}>
            {categories.map((item, index) => (
              <React.Fragment key={index}>
                <span className={classes.categoryItem}>{item}</span>
                {index < categories.length - 1 && (
                  <span className={classes.divider} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <WhyChoosePrimeBridge />
    </div>
  );
};

export default PageBody;
